export interface FeatureItem {
  id: string;
  icon: string;
  title: string;
  desc: string;
}

export const features: FeatureItem[] = [
  {
    id: "feat-library",
    icon: "ri-film-line",
    title: "海量影视聚合",
    desc: "电影、电视剧、综艺、动漫与纪录片集中在一个客户端内，按类型与年份归类，找片不必来回切换多个应用。",
  },
  {
    id: "feat-quality",
    icon: "ri-hd-line",
    title: "高清流畅播放",
    desc: "内置多档清晰度，支持 720P、1080P 与部分 4K 片源，播放时自动匹配当前网络，减少缓冲等待。",
  },
  {
    id: "feat-sync",
    icon: "ri-refresh-line",
    title: "多端进度同步",
    desc: "手机、平板、电视与网页端共用同一账号，收藏列表与观看进度自动同步，换设备接着看。",
  },
  {
    id: "feat-recommend",
    icon: "ri-magic-line",
    title: "智能片单推荐",
    desc: "根据观看记录与偏好生成推荐列表，提供“猜你喜欢”“近期热门”等片单，缩短挑片时间。",
  },
  {
    id: "feat-offline",
    icon: "ri-download-2-line",
    title: "离线缓存观看",
    desc: "支持将剧集缓存到本机，通勤、地铁或飞行途中无需联网也能继续观看已缓存的内容。",
  },
  {
    id: "feat-clean",
    icon: "ri-layout-grid-line",
    title: "简洁无干扰界面",
    desc: "首页分区清晰、操作路径短，搜索、播放、收藏等高频动作一步可达，长辈也能快速上手。",
  },
];

export interface TipItem {
  id: string;
  step: string;
  title: string;
  desc: string;
}

export const tips: TipItem[] = [
  {
    id: "tip-quality",
    step: "01",
    title: "卡顿时先切清晰度",
    desc: "播放页右下角可手动选择清晰度。网络波动时切换到「高清」往往比等待缓冲更快恢复流畅。",
  },
  {
    id: "tip-search",
    step: "02",
    title: "善用搜索与筛选",
    desc: "在搜索框输入片名关键字，再按类型、地区、年份筛选，可在海量片源中快速定位目标影片。",
  },
  {
    id: "tip-favorite",
    step: "03",
    title: "收藏管理待看片单",
    desc: "把想看的影片加入收藏，客户端会按更新时间提醒，追剧不容易漏集。",
  },
  {
    id: "tip-cache",
    step: "04",
    title: "出行前提前缓存",
    desc: "在 Wi-Fi 环境下缓存剧集，并选择“仅 Wi-Fi 下载”，避免在移动网络下消耗过多流量。",
  },
  {
    id: "tip-cast",
    step: "05",
    title: "一键投屏到大屏",
    desc: "手机与电视处于同一局域网时，点击播放页的投屏按钮，即可把画面推送到电视观看。",
  },
];

export interface SafetyItem {
  id: string;
  icon: string;
  title: string;
  desc: string;
}

export const safetyItems: SafetyItem[] = [
  {
    id: "safe-source",
    icon: "ri-shield-check-line",
    title: "只从官方页面获取",
    desc: "安装包仅通过本页提供的官方渠道获取，避免从论坛、群文件或第三方网盘下载来路不明的版本。",
  },
  {
    id: "safe-verify",
    icon: "ri-file-check-line",
    title: "安装前核对版本信息",
    desc: "对照本页「更新日志」中的版本号与文件大小，确认下载到的安装包与页面标注一致后再安装。",
  },
  {
    id: "safe-permission",
    icon: "ri-lock-line",
    title: "谨慎授予权限",
    desc: "客户端正常使用只需存储与网络权限。若安装包索取通讯录、短信等无关权限，请暂停安装并核查来源。",
  },
  {
    id: "safe-fix",
    icon: "ri-tools-line",
    title: "异常时重新安装",
    desc: "遇到闪退、白屏等异常，先卸载当前版本，再通过本页重新获取最新安装包并覆盖安装。",
  },
];

export interface StatItem {
  id: string;
  value: string;
  label: string;
}

export const heroStats: StatItem[] = [
  { id: "stat-version", value: "v3.2.1", label: "当前最新版本" },
  { id: "stat-platform", value: "6 类", label: "适配设备类型" },
  { id: "stat-time", value: "约 3 分钟", label: "平均安装耗时" },
  { id: "stat-free", value: "免费", label: "客户端下载使用" },
];